import { Pressable } from "react-native";

import { Button, Col, Icon, Row, TextBody, TextTitle } from "../lib";
import { Avatar } from "./avatar";
import {
  formatDaysLeft,
  getDateFromServerTimestamp,
  getTierName,
  User,
} from "../services";

type Props = {
  user: User;
  onPressAvatar: () => void;
  onPressPremium: () => void;
};

export function ProfileHeader({ onPressAvatar, user, onPressPremium }: Props) {
  // Vars
  const tierName = getTierName(user.premium_tier);

  // Render
  return (
    <Row p="4">
      <Pressable onPress={onPressAvatar}>
        <Avatar uri={user.image?.url} />
      </Pressable>
      <Col.TBL p="4">
        <Col>
          <Row.L>
            <TextTitle>{user.name}</TextTitle>
            {!!user.city?.name && (
              <TextBody small ml="1">
                ({user.city?.name})
              </TextBody>
            )}
          </Row.L>
          <TextBody small>{user.email}</TextBody>
          <TextBody small>{user.phone}</TextBody>
        </Col>
        {user.premium && user.premium_expires_at ? (
          <Pressable onPress={onPressPremium}>
            <Row.L>
              <TextTitle mr="1">{tierName ? tierName : "Premium"}</TextTitle>
              <Icon name="star-circle" em />
            </Row.L>
            <TextBody small>
              {formatDaysLeft(
                getDateFromServerTimestamp(user.premium_expires_at)
              )}
            </TextBody>
          </Pressable>
        ) : (
          <Button compact em onPress={onPressPremium}>
            Buy Premium
          </Button>
        )}
      </Col.TBL>
    </Row>
  );
}
